import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { FRONT_OFFICE_SHORTCUT_SECTIONS } from '../constants/frontOfficeShortcuts';
import './FrontOfficeNew.css';

const FrontOfficeShortcuts = () => {
  const totalShortcuts = useMemo(
    () => FRONT_OFFICE_SHORTCUT_SECTIONS.reduce((sum, section) => sum + section.items.length, 0),
    []
  );

  return (
    <div className="frontoffice-shortcuts-page">
      <div className="frontoffice-shortcuts-page-shell">
        <div className="frontoffice-shortcuts-page-topbar">
          <Link to="/frontoffice-new" className="btn btn-outline-secondary btn-sm">
            <i className="bi bi-arrow-left me-2"></i>
            Back To Front Office
          </Link>
          <div className="frontoffice-shortcuts-page-pill">
            <i className="bi bi-keyboard me-2"></i>
            {totalShortcuts} shortcuts
          </div>
        </div>

        <div className="frontoffice-shortcuts-page-hero">
          <div>
            <div className="frontoffice-shortcuts-eyebrow">Keyboard Reference</div>
            <h1 className="frontoffice-shortcuts-page-title">Front Office Shortcut Guide</h1>
            <p className="frontoffice-shortcuts-page-copy mb-0">
              This page is your quick desk-side reference for call handling, caller workflow, and agent tools.
              Use <strong> F2 </strong>
              inside Front Office to reopen the in-app shortcut guide any time.
            </p>
          </div>
          <div className="frontoffice-shortcuts-page-tip">
            <div className="frontoffice-shortcuts-page-tip-label">Daily flow</div>
            <div className="frontoffice-shortcuts-page-tip-copy">
              Open panels with
              <strong> Ctrl + Alt </strong>
              combos, and use
              <strong> Ctrl + Alt + Shift </strong>
              for the form workflow actions.
            </div>
          </div>
        </div>

        <div className="frontoffice-shortcuts-body">
          {FRONT_OFFICE_SHORTCUT_SECTIONS.map((section) => (
            <section key={section.title} className="frontoffice-shortcuts-section">
              <div className="frontoffice-shortcuts-section-header">
                <h2 className="frontoffice-shortcuts-section-title">{section.title}</h2>
                {section.description ? (
                  <p className="frontoffice-shortcuts-section-copy mb-0">{section.description}</p>
                ) : null}
              </div>

              <div className="frontoffice-shortcuts-list">
                {section.items.map((item) => (
                  <div key={item.id} className="frontoffice-shortcuts-item">
                    <div className="frontoffice-shortcuts-item-copy">
                      <div className="frontoffice-shortcuts-item-title">{item.title}</div>
                      <div className="frontoffice-shortcuts-item-description">{item.description}</div>
                    </div>
                    <div className="frontoffice-shortcuts-keys" aria-label={`Shortcut ${item.combo}`}>
                      {String(item.combo || '')
                        .split(' / ')
                        .map((variant) => (
                          <div key={variant} className="frontoffice-shortcuts-keyset">
                            {variant.split('+').map((part) => (
                              <kbd key={part} className="frontoffice-shortcuts-kbd">
                                {part}
                              </kbd>
                            ))}
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FrontOfficeShortcuts;
